import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './components/Auth/AuthContext.jsx';
import ProtectedRoute from './components/Auth/ProtectedRoute.jsx';
import './App.css';
import Header from './components/Header/Header.jsx';
import Footer from './components/Footer/Footer.jsx';
import Home from './components/Home/Home.jsx';
import SignIn from './components/Auth/SignIn/SignIn.jsx';
import Register from './components/Auth/Register/Register.jsx';
import AboutProgram from './components/Home/AboutProgram/AboutProgram.jsx';
import Profile from './components/Home/Profile/Profile.jsx';
import RecuperarContrasena from './components/Auth/SignIn/RecuperarContra/RecuperarContrasena.jsx';
import CambiarContrasena from './components/Auth/SignIn/RecuperarContra/CambiarContrasena.jsx';
import ControlPanel from './components/Admin/ControlPanel/ControlPanel.jsx'
import Tutor from './components/Home/Tutor/Tutor.jsx';
import Themes from './components/Header/Themes/Themes.jsx';
import Carreras from './components/Home/Tutor/tutorcomponentes/AreasProfesionales.jsx';
import DirectorioUniversidades from './components/Home/Tutor/tutorcomponentes/DirectorioUniversidades.jsx';
import BecasVigentes from './components/Home/Tutor/tutorcomponentes/BecasVigentes.jsx';
import DetallePaso from './components/Home/Pasos/DetallePaso.jsx';
import DetalleSeccion from './components/Home/Pasos/DetalleSeccion.jsx';
import DetalleTest from './components/Home/Pasos/DetalleTest.jsx';
import MapaUniversidades from './components/Home/Tutor/tutorcomponentes/MapaUniversidades.jsx';
import VideosRecorridos from './components/Home/Tutor/tutorcomponentes/VideosRecorridos.jsx';
import JuegoCarrera from './components/Home/CarreraUniversitaria/JuegoCarrera.jsx'
import MasInfo from './components/Home/AboutProgram/MasInfo.jsx';
import RegisterTutor from './components/Auth/Register/RegisterTutor.jsx';
import VerificarCorreo from './components/Auth/Register/VerificarCorreo.jsx';
import { Navigate } from 'react-router-dom';

function AppContent() {
  const location = useLocation(); 

  const hideFooter = ['/controlpanel']; 
  const shouldHideFooter = hideFooter.includes(location.pathname); 

  return (
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-program" element={<AboutProgram />} />
          <Route path="/masInfo" element={<MasInfo/>} />
          <Route path="/tutor" element={<Tutor/>} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/register" element={<Register />} />
          <Route path="/registertutor" element={<RegisterTutor />} />
          <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
          <Route path="/cambiar-contrasena/:token" element={<CambiarContrasena />} />
          <Route path='/mapaUniversidades' element={<MapaUniversidades />} />
          <Route path='/verificarCorreo' element={<VerificarCorreo/>} />

          {/* Ruta para usuario autenticado. */}
          <Route 
            path="/profile"
            element= { 
              <ProtectedRoute requireAuth={true}>
                <Profile />
              </ProtectedRoute>
            }
            />

          <Route
            path="/becasVigentes"
            element= { 
              <ProtectedRoute requireAuth={true} redirectTo='/masInfo'>
                <BecasVigentes />
              </ProtectedRoute>
            }
          />

          <Route
            path="/areasProfesionales"
            element= { 
              <ProtectedRoute requireAuth={true} redirectTo='/masInfo'>
                <Carreras />
              </ProtectedRoute>
            }
          />

          <Route
            path="/directorioUniversidades"
            element= { 
              <ProtectedRoute requireAuth={true} redirectTo='/masInfo'>
                <DirectorioUniversidades />
              </ProtectedRoute>
            }
          />

          <Route
            path="/videosRecorridos"
            element= { 
              <ProtectedRoute requireAuth={true} redirectTo='/masInfo'>
                <VideosRecorridos />
              </ProtectedRoute>
            }
          />

          {/*Rutas para alumnos*/}
          <Route 
            path="/temas"
            element= { 
              <ProtectedRoute requireAuth={true} requiredUserType={1}>
                <Themes />
              </ProtectedRoute>
            }
          />

          <Route 
            path="/paso/:pa_clave"
            element= { 
              <ProtectedRoute requireAuth={true} requiredUserType={1}>
                <DetallePaso />
              </ProtectedRoute>
            }
          />

          <Route 
            path="/paso/:pa_clave/seccion/:se_clave"
            element= { 
              <ProtectedRoute requireAuth={true} requiredUserType={1}>
                <DetalleSeccion />
              </ProtectedRoute>
            }
          />

          <Route 
            path="/paso/:pa_clave/test/:te_clave"
            element= { 
              <ProtectedRoute requireAuth={true} requiredUserType={1}>
                <DetalleTest />
              </ProtectedRoute>
            }
          />

          <Route 
            path="/carrera-universitaria"
            element= { 
              <ProtectedRoute requireAuth={true} requiredUserType={1}>
                <JuegoCarrera />
              </ProtectedRoute>
            }
          />

          {/*Ruta de administradores*/}
          <Route
            path ="/controlpanel"
            element = { 
              <ProtectedRoute requireAuth={true} requiredUserType={2}>
                <ControlPanel /> 
              </ProtectedRoute>
            }
          />

          {/* Captura todas las rutas no definidas y redirige a home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        {!shouldHideFooter && <Footer/>}
      </div>
      );
}

function App() { 
  return (
    <Router>
      <AuthProvider>
      <AppContent /> 
      </AuthProvider>
    </Router>
  ); 
}

export default App;